export default "__VITE_ASSET__DxqEt0rD__"